module.exports = __webpack_public_path__ + "assets/img/AstonRX-Landing-Page-w540.b597e9b1.webp";